/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  ComponentFactoryResolver,
  Directive,
  HostListener,
  Injector,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import {NgControl} from '@angular/forms';
import {DialogComponent} from './dialog/dialog.component';
import {combineLatest, Subject} from 'rxjs';
import {ConfirmationDialogModel} from './confirmation-dialog.model';

@Directive({
  selector: '[wellDialogInsertion]'
})
export class DialogInsertionDirective implements OnInit {

  @Input() dialogData: ConfirmationDialogModel | undefined = undefined;

  focus: Subject<boolean> = new Subject<boolean>();
  componentRef: any | undefined = undefined;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private control: NgControl,
    private viewContainerRef: ViewContainerRef
  ) {

  }

  @HostListener('focusin', ['$event']) onFocus(event: any) {
    this.focus.next(true);
  }

  @HostListener('focusout', ['$event']) onFocusout(event: any) {
    this.focus.next(false);
  }

  ngOnInit(): void {
    this.subscribeToControlChanges();
  }

  appendDialogComponentToBody() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DialogComponent);
    this.componentRef = componentFactory.create(this.injector);

    this.componentRef.instance.dialogData = this.dialogData;
    this.componentRef.instance.ngControl = this.control;

    this.viewContainerRef.insert(this.componentRef.hostView);
  }

  private subscribeToControlChanges() {
    if (!this.control.valueChanges) return;
    combineLatest([this.control.valueChanges, this.focus]).subscribe(
      ([_, hasFocus]) => {
        if (hasFocus) {
          if (this.dialogData?.enabled && !this.dialogData.confirmationState) {
            this.appendDialogComponentToBody();
          }
        }
      }
    );
  }

}
